import { Navbar, Nav, Container, NavDropdown, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import {
  FaUser,
  FaRegListAlt,
  FaUsers,
  FaWhatsappSquare,
  FaPhoneAlt,
  FaUserCircle,
  FaRegEdit,
  FaInfoCircle,
  FaCommentDots,
  FaChevronUp,
  FaChevronDown,
  FaBirthdayCake,
  FaChartLine,
} from "react-icons/fa"; // Add the icons you need
import { FaClock } from "react-icons/fa6";
import { CgMenuBoxed } from "react-icons/cg";
import {
  RiPassPendingFill,
  RiFolderUploadFill,
  RiQrCodeFill,
  RiBuilding4Fill,
  RiLogoutCircleRLine,
  RiBodyScanFill,
  RiCalendarEventFill,
  RiHome8Line,
} from "react-icons/ri";
import { CgGym, CgProfile } from "react-icons/cg";
import {
  MdQrCode2,
  MdManageAccounts,
  MdOutlinePlayCircleOutline,
} from "react-icons/md";
import {
  IoMdCloseCircleOutline,
  IoIosColorPalette,
  IoLogoWhatsapp,
} from "react-icons/io";
import { IoFastFoodSharp } from "react-icons/io5";
import { GiWeightLiftingUp } from "react-icons/gi";
import { AiTwotoneDatabase } from "react-icons/ai";

import { Link, useNavigate } from "react-router-dom";
import { setCredentials } from "../slices/authSlice";

import preferredLanguage from "../assets/preferredLanguage.json";
import { getCurrentDate, getDateOfLast } from "../utils/getCurrentDate";
import { getTodaysVisitors, getTodaysExpiredUsers } from "../utils/schedulars";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  useAssociateLogoutMutation,
  useLazyGetMyDetailsQuery,
} from "../slices/associatesSlice";
import { useLazyGetWsMessageQuery } from "../slices/wsMessageSlice";
import { useGetMemberWiseAnalyticsQuery } from "../slices/dashBoardSlice";
import GymSwitcher from "./GymSwitcher";
import { performMultiGymLogout } from "../utils/performMultiGymLogout";

const HeaderLeft = function ({ leftMenuOpen, setExpandMenu }) {
  const { userInfo } = useSelector((state) => state.auth);
  // const domainUrl = window?.location?.origin;
  const selectedLanguage = userInfo?.preferredLanguage
    ? userInfo?.preferredLanguage
    : "English";

  const [unReadMsgCount, setUnReadMsgCount] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApi] = useAssociateLogoutMutation();
  let gymId;
  if (userInfo) {
    gymId = userInfo?.gymId?._id;
  }

  // Long-lived intervals/timeouts below must read the latest userInfo, not
  // the one captured when they were registered — otherwise a gym switch would
  // let a stale dispatch overwrite the newly selected gym's data.
  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const [triggerMyDetails, { data: myDetails, isLoading, error }] =
    useLazyGetMyDetailsQuery();
  const [getWsMessages] = useLazyGetWsMessageQuery();

  const buildWsMsgQuery = (info) =>
    new Date(info?.lastRetrivedDate_wsMsgs) <
      new Date(new Date().toISOString().split("T")[0]) ||
    !info?.lastRetrivedDate_wsMsgs
      ? `?gymId=${info?.gymId?._id}&updatedAt[gte]=${getDateOfLast(
          14
        )}T00:00:00.125Z&updatedAt[lte]=${getCurrentDate()}T23:59:59.125Z
      `
      : `?gymId=${info?.gymId?._id}&updatedAt[gte]=${info?.lastRetrivedDate_wsMsgs}&sort=-createdAt`;

  const [getApiQuery, setGetApiQuery] = useState(() =>
    buildWsMsgQuery(userInfo)
  );

  // Recompute the WhatsApp query whenever the active gym changes (multi-gym
  // switch); otherwise messages would keep being fetched for the old gym.
  useEffect(() => {
    setGetApiQuery(buildWsMsgQuery(userInfoRef.current));
  }, [userInfo?.gymId?._id]);

  // const today = new Date().toISOString().split("T")[0];

  // const shouldFetchAnalytics =
  //   !userInfo?.lastRetrieved_userAnalytics ||
  //   userInfo.lastRetrieved_userAnalytics.split("T")[0] !== today;

  // const {
  //   data: analyticsData,
  //   isLoading: analyticsDataLoading,
  //   error: analyticsDataError,
  //   refetch,
  // } = useGetMemberWiseAnalyticsQuery(
  //   { token: userInfo?.token },
  //   {
  //     skip: !shouldFetchAnalytics,
  //   }
  // );

  useEffect(() => {
    if (!userInfo?.token) return;

    let intervalId;
    let timeoutId;

    const callWsApi = async () => {
      const currentIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
      );

      const hour = currentIST.getHours();
      if (hour < 6 || hour > 21) return;

      try {
        const info = userInfoRef.current;
        if (!info?.token) return;
        // Skip if the query still targets a previously active gym.
        if (!getApiQuery.includes(info?.gymId?._id)) return;

        const currTime = new Date().toISOString();
        const res = await getWsMessages({
          query: getApiQuery,
          token: info.token,
        }).unwrap();

        if (!res?.length) return;

        const latestInfo = userInfoRef.current;
        if (latestInfo?.gymId?._id !== info?.gymId?._id) return;

        const existingMsgs = latestInfo.wsMsgs || [];
        const merged = [...res, ...existingMsgs];

        const uniqueMsgs = Array.from(
          new Map(merged.map((msg) => [msg._id, msg])).values()
        );

        dispatch(
          setCredentials({
            ...latestInfo,
            wsMsgs: uniqueMsgs,
            lastRetrivedDate_wsMsgs: currTime,
          })
        );
      } catch (err) {
        console.error("WhatsApp API failed", err);
      }
    };

    const now = new Date();
    const currentIST = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    const nextHourIST = new Date(currentIST);
    nextHourIST.setHours(currentIST.getHours() + 1, 0, 0, 0);

    const delay = nextHourIST.getTime() - currentIST.getTime();

    timeoutId = setTimeout(() => {
      callWsApi();
      intervalId = setInterval(callWsApi, 60 * 60 * 1000);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [userInfo?.token, getApiQuery]);

  // useEffect(() => {
  //   if (analyticsData?.data && userInfo?.allUsers?.length) {
  //     const updatedAnalytics = analyticsData.data.map((member) => ({
  //       ...member,
  //     }));

  //     const analyticsMap = {};

  //     updatedAnalytics.forEach((member) => {
  //       analyticsMap[member.userId] = member;
  //     });

  //     updatedAnalytics.forEach((member) => {
  //       const user = userInfo?.allUsers?.find(
  //         (u) => String(u.userId) === String(member.userId)
  //       );

  //       if (user?.joinedDate) {
  //         const joinedDate = new Date(user.joinedDate);
  //         const today = new Date();

  //         let months =
  //           (today.getFullYear() - joinedDate.getFullYear()) * 12 +
  //           (today.getMonth() - joinedDate.getMonth());

  //         if (today.getDate() < joinedDate.getDate()) {
  //           months--;
  //         }

  //         if (months <= 0) months = 1;

  //         member.amountPaidPerMonth = Number(
  //           (member.totalAmountPaidTillNow / months).toFixed(2)
  //         );

  //         member.joinedDate = user.joinedDate;
  //         member.firstName = user.firstName;
  //         member.lastName = user.lastName;
  //         member._id = user._id;
  //         member.imageUploadedTime = user.imageUploadedTime;
  //       } else {
  //         member.amountPaidPerMonth = 0;
  //       }
  //     });

  //     [...updatedAnalytics]
  //       .sort(
  //         (a, b) =>
  //           (b.totalAmountPaidTillNow || 0) - (a.totalAmountPaidTillNow || 0)
  //       )
  //       .forEach((member, index) => {
  //         analyticsMap[member.userId].totalPaidRank = index + 1;
  //       });

  //     [...updatedAnalytics]
  //       .sort(
  //         (a, b) => (b.amountPaidPerMonth || 0) - (a.amountPaidPerMonth || 0)
  //       )
  //       .forEach((member, index) => {
  //         analyticsMap[member.userId].perMonthAmountRank = index + 1;
  //       });

  //     [...updatedAnalytics]
  //       .sort(
  //         (a, b) =>
  //           (b.actualAttendanceDays || 0) - (a.actualAttendanceDays || 0)
  //       )
  //       .forEach((member, index) => {
  //         analyticsMap[member.userId].attendanceDaysRank = index + 1;
  //       });

  //     [...updatedAnalytics]
  //       .sort(
  //         (a, b) =>
  //           (b.activeMembershipPercentage || 0) -
  //           (a.activeMembershipPercentage || 0)
  //       )
  //       .forEach((member, index) => {
  //         analyticsMap[member.userId].activeMembershipRank = index + 1;
  //       });

  //     dispatch(
  //       setCredentials({
  //         ...userInfo,
  //         userAnalytics: {
  //           ...analyticsData,
  //           data: updatedAnalytics,
  //         },
  //         lastRetrieved_userAnalytics: new Date().toISOString(),
  //       })
  //     );
  //   }
  // }, [analyticsData, userInfo?.allUsers]);

  // Shared with the mobile header: logout drops only the ACTIVE gym and falls
  // back to the most recently used parked gym.
  const handleLogout = async () => {
    await performMultiGymLogout({
      userInfo,
      dispatch,
      navigate,
      logoutApi,
      triggerMyDetails,
    });
  };
  const [visitorsReminder, setVisitorsReminder] = useState(false);
  const [expiredUsersReminder, setExpiredUsersReminder] = useState(false);
  const [isUserManagementExpanded, setIsUserManagementExpanded] =
    useState(true);
  const [isExpanded, setIsExpanded] = useState(true);

  const getTodayIST = () =>
    new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    });

  useEffect(() => {
    if (!userInfo?.token) return;
    const interval = setInterval(async () => {
      const info = userInfoRef.current;
      if (!info?.token) return;

      const nowIST = new Date(
        new Date().toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        })
      );

      const currentHour = nowIST?.getHours();
      const todayIST = getTodayIST();

      if (info?.lastMyDetailsSync === todayIST) return;

      if (currentHour !== 8) return;

      const res = await triggerMyDetails({ token: info?.token });

      if (res?.data?.gymId) {
        const latestInfo = userInfoRef.current;
        // The active gym may have been switched while the request was in
        // flight — never merge one gym's details into another's session.
        if (latestInfo?.gymId?._id !== info?.gymId?._id) return;

        dispatch(
          setCredentials({
            ...latestInfo,
            gymId: res?.data?.gymId,
            lastMyDetailsSync: todayIST,
          })
        );
        clearInterval(interval);
      }
    }, 360000);

    return () => clearInterval(interval);
  }, [userInfo?.token]);

  // useEffect(() => {
  //   const timeout = setTimeout(async () => {
  //     console.log("Inside timeout: " + new Date());

  //     const now = new Date();

  //     // Get current time in IST
  //     const nowIST = new Date(
  //       now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  //     );
  //     const currentHour = nowIST.getHours();

  //     // Calculate time difference from last execution
  //     const lastExecutedOn = userInfo?.reminderExecutedOn || 0; // Default to 0 if not set
  //     const timeSinceLastExecution = now.getTime() - lastExecutedOn;

  //     console.log("Time since last execution: " + timeSinceLastExecution);

  //     if (
  //       (currentHour >= 8 && currentHour < 12) || // Morning condition
  //       (currentHour >= 17 && currentHour < 21) // Evening condition
  //     ) {
  //       // Check if at least 3 hours (10800000ms) have passed
  //       if (timeSinceLastExecution >= 10800000) {
  //         if (userInfo?.token && !visitorsReminder) {
  //           const vst = await getTodaysVisitors({ userInfo, domainUrl });
  //           if (vst?.length > 0) setVisitorsReminder(true);
  //         }

  //         if (userInfo?.token && !expiredUsersReminder) {
  //           const usrs = await getTodaysExpiredUsers({ userInfo, domainUrl });
  //           if (usrs?.length > 0) setExpiredUsersReminder(true);
  //         }

  //         // Update reminderExecutedOn timestamp
  //         dispatch(
  //           setCredentials({
  //             ...userInfo,
  //             reminderExecutedOn: now.getTime(),
  //           })
  //         );
  //       } else {
  //         console.log("Not enough time has passed since the last execution.");
  //       }
  //     } else {
  //       console.log("Not within the allowed time range.");
  //     }
  //   }, 15000); // Execute after 10 seconds

  //   return () => clearTimeout(timeout); // Cleanup on component unmount
  // }, [userInfo, visitorsReminder, expiredUsersReminder, dispatch]);
  const bgColor = userInfo?.gymId?.themeColors?.headerBg || "rgb(10, 90, 106)";
  const headerTextColor = userInfo?.gymId?.themeColors?.headerText || "#FFFFFF";

  useEffect(() => {
    const unreadCount =
      userInfo?.wsMsgs?.reduce((count, msg) => {
        if (
          msg.messageKind?.trim() === "In_Coming" &&
          msg.messageResponse?.toLowerCase() !== "read"
        ) {
          return count + 1;
        }
        return count;
      }, 0) || 0;

    setUnReadMsgCount(unreadCount);
  }, [userInfo?.wsMsgs]);

  const getTodayMonthDay = () => {
    const today = new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    });
    return today.slice(5);
  };
  const birthdayUsers = useMemo(() => {
    if (!userInfo?.allUsers?.length) return [];

    const todayMD = getTodayMonthDay();

    const filtered = userInfo.allUsers.filter((user) => {
      if (!user?.dateOfBirth) return false;

      const dob = new Date(user.dateOfBirth)
        .toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })
        .slice(5);

      return dob === todayMD;
    });

    // console.log(" Filtered  birthdayUsers:", filtered);

    return filtered;
  }, [userInfo?.allUsers]);
  const hasBirthdayToday = birthdayUsers.length > 0;

  return (
    <header
      className="whiteTheme"
      style={{
        position: "sticky",
        top: "0px",
        zIndex: 6,
        borderBottom: "0.5px solid rgb(7, 159, 43, 0.8)",
        backgroundColor: bgColor,
      }}
      // className={`${userInfo?.themeColor}ThemeHeaderTop`}
    >
      {userInfo ? (
        <>
          <Navbar
            style={{
              // backgroundColor: "inherit", // Use any hex color code
              color: headerTextColor, // Set the text color
              height: "40px",
              marginTop: "0.2px",
              backgroundColor: bgColor,
            }}
          >
            <Container
              style={{
                // backgroundColor: "inherit", // Use any hex color code
                color: headerTextColor, // Set the text color
                height: "40px",
                marginTop: "0.2px",
              }}
            >
              <LinkContainer
                to="/markAttendance"
                style={{ color: headerTextColor }}
              >
                <Navbar.Brand>
                  {/* <img src={logo} alt="zpotter"></img>{" "} */}
                  {/* <label style={{ fontSize: "1.5rem" }}>ZPOTTER</label> */}
                  zpotter
                </Navbar.Brand>
              </LinkContainer>
              {/* {new Date(getCurrentDate()) <= new Date("2026-06-09") && (
                <Nav.Link
                  style={{
                    color: "orange",
                    whiteSpace: "nowrap",
                    marginLeft: "7rem",
                    fontSize: "1.2rem",
                    textDecoration: "underline",
                  }}
                  href="https://youtu.be/TbPvys0jYXk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>Member App Available - click</strong>
                </Nav.Link>
              )} */}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  color: headerTextColor,
                }}
              >
                {userInfo ? (
                  <GymSwitcher headerTextColor={headerTextColor} />
                ) : (
                  <label style={{ fontSize: "1.5rem", color: headerTextColor }}>
                    {" "}
                    zpotter
                  </label>
                )}
                {/* {visitorsReminder && (
                  <div style={{ margin: "0px 20px" }}>
                    <Link
                      to="/visitorsReminder"
                      className="twinkle-text"
                      style={{
                        color: "orange",
                      }}
                    >
                      Check Enquiry
                    </Link>
                    <Link
                      onClick={() => setVisitorsReminder(false)}
                      style={{
                        margin: "0px 2px",
                        color: "orange",
                      }}
                    >
                      <IoMdCloseCircleOutline />
                    </Link>
                  </div>
                )} */}
                {/* {expiredUsersReminder && (
                  <div style={{ margin: "0px 20px" }}>
                    <Link
                      to="/todaysExpiringMembers"
                      className="twinkle-text"
                      style={{
                        color: "orange",
                      }}
                    >
                      Check Expiring Members
                    </Link>
                    <Link
                      onClick={() => setExpiredUsersReminder(false)}
                      style={{
                        margin: "0px 2px",
                        color: "orange",
                      }}
                    >
                      <IoMdCloseCircleOutline />
                    </Link>
                  </div>
                )} */}
              </div>
              <Button
                variant="link"
                disabled={!hasBirthdayToday}
                onClick={() =>
                  navigate("/events", { state: { showBirthdays: true } })
                }
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  textDecoration: "none",
                  opacity: hasBirthdayToday ? 1 : 0.5,
                  color: headerTextColor,
                  marginRight: "1rem",
                }}
              >
                <FaBirthdayCake
                  style={{
                    color: hasBirthdayToday ? "#25D366" : "#ccc",
                    fontSize: "1.2rem",
                  }}
                />

                {hasBirthdayToday && (
                  <span
                    style={{
                      background: "red",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 6px",
                      fontSize: "0.7rem",
                    }}
                  >
                    {birthdayUsers.length}
                  </span>
                )}
              </Button>
              <LinkContainer to="/feedback">
                <Navbar.Brand
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    color: headerTextColor,
                    marginRight: "1rem",
                  }}
                >
                  <FaCommentDots
                    style={{ fontSize: "0.8rem", color: "#fff" }}
                  />
                  <small style={{ color: headerTextColor }}>Feedback</small>
                </Navbar.Brand>
              </LinkContainer>
              <LinkContainer
                to="/wsChat"
                style={{
                  color: headerTextColor,
                  borderRadius: "5px",
                  padding: "0.2rem 0.4rem",
                  marginRight: "1rem",
                }}
              >
                <Navbar.Brand>
                  <IoLogoWhatsapp
                    style={{ marginRight: "2px", color: "green" }}
                  />
                  <small
                    style={{
                      color: "red",
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                    }}
                  >
                    {unReadMsgCount}
                  </small>
                </Navbar.Brand>
              </LinkContainer>
              {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav"> */}
              <Nav
                className="ms-auto"
                style={{
                  backgroundColor: "inherit",
                  color: headerTextColor,
                }}
              >
                {userInfo ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "10",
                        width: "100%",
                        color: headerTextColor,
                      }}
                    >
                      <FaUserCircle style={{ marginRight: "1px" }} />
                    </div>

                    <NavDropdown
                      style={{ marginRight: "6rem", color: headerTextColor }}
                      title={
                        <span style={{ color: headerTextColor }}>More</span>
                      }
                    >
                      <LinkContainer to="/profile">
                        <NavDropdown.Item>
                          {" "}
                          <CgProfile style={{ marginRight: "3px" }} />
                          {preferredLanguage[selectedLanguage]?.myProfile}
                        </NavDropdown.Item>
                      </LinkContainer>
                      {userInfo.role === "owner" ||
                      userInfo.role === "Super Admin" ? (
                        <>
                          <LinkContainer to="/updateAttendancePageScreen">
                            <NavDropdown.Item>
                              <FaRegEdit style={{ marginRight: "3px" }} />
                              {preferredLanguage[selectedLanguage]?.editAttPage}
                            </NavDropdown.Item>
                          </LinkContainer>

                          {/* <LinkContainer to="/promotionalMessage">
                            <NavDropdown.Item>
                              {" "}
                              <FaWhatsapp style={{ marginRight: "2px" }} />
                              {preferredLanguage[selectedLanguage]?.sendAds}
                            </NavDropdown.Item>
                          </LinkContainer> */}
                        </>
                      ) : (
                        <></>
                      )}

                      <LinkContainer to="/showToVisitors">
                        <NavDropdown.Item>
                          <FaInfoCircle style={{ marginRight: "2px" }} />
                          Member Communication
                        </NavDropdown.Item>
                      </LinkContainer>

                      {userInfo.role === "owner" ||
                      userInfo.role === "Super Admin" ||
                      userInfo.role === "Admin" ? (
                        <>
                          <LinkContainer to="/uploadUsers">
                            <NavDropdown.Item>
                              <RiFolderUploadFill />
                              {preferredLanguage[selectedLanguage]?.bulkUpload}
                            </NavDropdown.Item>
                          </LinkContainer>
                        </>
                      ) : (
                        ""
                      )}
                      <LinkContainer to="/contactUs">
                        <NavDropdown.Item>
                          {" "}
                          <FaPhoneAlt style={{ marginRight: "2px" }} />
                          Contact Us
                        </NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Item onClick={handleLogout}>
                        <RiLogoutCircleRLine style={{ marginRight: "3px" }} />
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  </>
                ) : (
                  <LinkContainer to="/login">
                    <Nav.Link>
                      <FaUser />
                      Login
                    </Nav.Link>
                  </LinkContainer>
                )}
              </Nav>
              {/* </Navbar.Collapse> */}
            </Container>
          </Navbar>
          {leftMenuOpen ? (
            <aside
              // className={`${userInfo.themeColor}ThemeHeaderLeft`}
              style={{
                width: leftMenuOpen ? "16rem" : "3rem", // Adjust width as needed
                // display: "none",
                height: "75vh", // Full viewport height
                position: "fixed", // Keep it fixed on the left
                top: "6.2rem",
                left: "0px",
                borderRight: "0.5px solid #ccc",
                padding: "2px",
                fontSize: "0.9rem",
                overflowY: "auto", // Allow scrolling for long content
              }}
            >
              {/* <div>
                {leftMenuOpen && (
                  <button
                    style={{
                      border: "0.5px solid",
                      padding: "5px",
                      cursor: "pointer",
                      borderRadius: "5px",
                      // Align the button to the right
                      marginLeft: "1.3rem", // Add some spacing
                      marginTop: "5px",
                    }}
                    onClick={(e) => setExpandMenu(false)}
                  >
                    <MdKeyboardDoubleArrowLeft style={{ marginRight: "2px" }} />{" "}
                    Hide Menu
                  </button>
                )}
              </div> */}
              <Navbar
                style={{
                  backgroundColor: "inherit", // Use any hex color code
                  color: "#ffffff", // Set the text color
                  marginTop: "0.2px",
                  height: "100%",
                  flexDirection: "column",
                }}
                expand="md"
                collapseOnSelect
              >
                <Container
                  style={{
                    backgroundColor: "inherit", // Use any hex color code
                    color: "#ffffff", // Set the text color
                    marginTop: "0.2px",
                  }}
                >
                  {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav"> */}
                  <Nav
                    className="flex-column"
                    style={{
                      backgroundColor: "inherit",
                      // color: "#ffffff",
                      alignItems: "left",
                      textShadow: "2px 2px 2px rgba(20, 18, 0, 0.15)",
                    }}
                  >
                    <LinkContainer to="/dashboard">
                      <Nav.Link>
                        {" "}
                        <RiHome8Line style={{ marginRight: "2px" }} />
                        Dashboard
                        {/* <span>
                            <MdOutlinePlayCircleOutline
                              className="videoIconStyle"
                              onClick={(e) => {
                                e.stopPropagation(); // prevent link click bubbling
                                e.preventDefault(); // prevent navigation
                                window.open(
                                  !userInfo?.gymId?.stateName ||
                                    userInfo?.gymId?.stateName === null ||
                                    userInfo?.gymId?.stateName === undefined ||
                                    userInfo?.gymId?.stateName === "Tamil Nadu"
                                    ? "https://youtu.be/zUOMEAJXuec"
                                    : "https://youtu.be/o7Y5TuxL0I4",
                                  "_blank"
                                );
                              }}
                            />
                          </span> */}
                      </Nav.Link>
                    </LinkContainer>
                    <hr
                      style={{
                        border: "1.5px solid grey",
                        margin: "5px 0",
                      }}
                    />

                    <Nav.Link
                      href="https://mytime.zpotter.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaClock style={{ marginRight: "2px" }} />
                      {preferredLanguage[selectedLanguage]?.attendance}

                      <span>
                        <MdOutlinePlayCircleOutline
                          className="videoIconStyle"
                          onClick={(e) => {
                            e.stopPropagation(); // prevent link click bubbling
                            e.preventDefault(); // prevent navigation
                            window.open(
                              !userInfo?.gymId?.stateName ||
                                userInfo?.gymId?.stateName === null ||
                                userInfo?.gymId?.stateName === undefined ||
                                userInfo?.gymId?.stateName === "Tamil Nadu"
                                ? "https://youtu.be/TEj3HtX8QXg"
                                : "https://youtu.be/o7Y5TuxL0I4",
                              "_blank"
                            );
                          }}
                        />
                      </span>
                    </Nav.Link>
                    {(userInfo.role === "owner" ||
                      userInfo.role === "Super Admin") && (
                      <>
                        {" "}
                        <LinkContainer to="/userSmartAnalytics">
                          <Nav.Link>
                            <FaChartLine style={{ marginRight: "2px" }} />
                            Smart Analytics
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://www.youtube.com/watch?v=osVWMFSh3sM"
                                      : "https://youtu.be/o7Y5TuxL0I4",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>
                      </>
                    )}
                    <LinkContainer to="/visitors">
                      <Nav.Link>
                        {" "}
                        <FaRegListAlt style={{ marginRight: "2px" }} />
                        Enquiry Tracker
                        <span>
                          <MdOutlinePlayCircleOutline
                            className="videoIconStyle"
                            onClick={(e) => {
                              e.stopPropagation(); // prevent link click bubbling
                              e.preventDefault(); // prevent navigation
                              window.open(
                                !userInfo?.gymId?.stateName ||
                                  userInfo?.gymId?.stateName === null ||
                                  userInfo?.gymId?.stateName === undefined ||
                                  userInfo?.gymId?.stateName === "Tamil Nadu"
                                  ? "https://youtu.be/zUOMEAJXuec"
                                  : "https://youtu.be/o7Y5TuxL0I4",
                                "_blank"
                              );
                            }}
                          />
                        </span>
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/memberAppQrCode">
                      <Nav.Link>
                        <MdQrCode2 style={{ marginRight: "2px" }} />
                        App For Members
                        <span>
                          <MdOutlinePlayCircleOutline
                            className="videoIconStyle"
                            onClick={(e) => {
                              e.stopPropagation(); // prevent link click bubbling
                              e.preventDefault(); // prevent navigation
                              window.open(
                                !userInfo?.gymId?.stateName ||
                                  userInfo?.gymId?.stateName === null ||
                                  userInfo?.gymId?.stateName === undefined ||
                                  userInfo?.gymId?.stateName === "Tamil Nadu"
                                  ? "https://youtu.be/TbPvys0jYXk"
                                  : "https://youtu.be/TbPvys0jYXk",
                                "_blank"
                              );
                            }}
                          />
                        </span>
                      </Nav.Link>
                    </LinkContainer>

                    {/* <LinkContainer to="/userRegistration">
                      <Nav.Link>
                        {" "}
                        <FaUserPlus style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.userReg}
                      </Nav.Link>
                    </LinkContainer>
                    <LinkContainer to="/attendanceList">
                      <Nav.Link>
                        {" "}
                        <FaClipboardList style={{ marginRight: "2px" }} />
                        {preferredLanguage[selectedLanguage]?.attendanceList}
                      </Nav.Link>
                    </LinkContainer> */}

                    <hr
                      style={{ border: "1.5px solid grey", margin: "5px 0" }}
                    />
                    <div
                      onClick={() =>
                        setIsUserManagementExpanded(!isUserManagementExpanded)
                      }
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "auto",
                        width: "100%",
                      }}
                    >
                      <strong style={{ flexGrow: 1 }}>
                        {"Member Management "}
                      </strong>
                      {isUserManagementExpanded ? (
                        <FaChevronUp
                          style={{ marginLeft: "0.5rem", color: "orange" }}
                        />
                      ) : (
                        <FaChevronDown
                          style={{ marginLeft: "0.5rem", color: "orange" }}
                        />
                      )}{" "}
                    </div>

                    {isUserManagementExpanded && (
                      <>
                        <LinkContainer to="/allUsers">
                          <Nav.Link>
                            <FaUsers style={{ marginRight: "2px" }} />
                            {preferredLanguage[selectedLanguage]?.allMembers}
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://youtu.be/vZOsTu_cBbw"
                                      : "https://youtu.be/o7Y5TuxL0I4",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>
                        {/* <LinkContainer to="/users">
                          <Nav.Link>
                            <FaUsers style={{ marginRight: "2px" }} />
                            {preferredLanguage[selectedLanguage]?.activeMember}
                          </Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/subsExpiredUsers">
                          <Nav.Link>
                            <FaUsersSlash style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]
                                ?.inActiveMembers
                            }
                          </Nav.Link>
                        </LinkContainer> */}
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ? (
                          <>
                            {/* <LinkContainer to="/subscriptions">
                              <Nav.Link>
                                <FaMoneyBillAlt
                                  style={{ marginRight: "2px" }}
                                />
                                {
                                  preferredLanguage[selectedLanguage]
                                    ?.subscriptions
                                }
                              </Nav.Link>
                            </LinkContainer> */}
                            <LinkContainer to="/ptUsers">
                              <Nav.Link>
                                <GiWeightLiftingUp
                                  style={{ marginRight: "2px" }}
                                />
                                PT Members
                                <span>
                                  <MdOutlinePlayCircleOutline
                                    className="videoIconStyle"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent link click bubbling
                                      e.preventDefault(); // prevent navigation
                                      window.open(
                                        !userInfo?.gymId?.stateName ||
                                          userInfo?.gymId?.stateName === null ||
                                          userInfo?.gymId?.stateName ===
                                            undefined ||
                                          userInfo?.gymId?.stateName ===
                                            "Tamil Nadu"
                                          ? "https://youtu.be/L03MNXl5SvE"
                                          : "https://youtu.be/o7Y5TuxL0I4",
                                        "_blank"
                                      );
                                    }}
                                  />
                                </span>
                              </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/workoutPlan">
                              <Nav.Link
                                disabled={
                                  userInfo?.gymId?.subscriptionType !==
                                    "Premium" &&
                                  userInfo?.gymId?.subscriptionType !== "Free"
                                }
                              >
                                <RiBodyScanFill
                                  style={{ marginRight: "2px" }}
                                />
                                Workout Plans
                                <span>
                                  <MdOutlinePlayCircleOutline
                                    className="videoIconStyle"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent link click bubbling
                                      e.preventDefault(); // prevent navigation
                                      window.open(
                                        !userInfo?.gymId?.stateName ||
                                          userInfo?.gymId?.stateName === null ||
                                          userInfo?.gymId?.stateName ===
                                            undefined ||
                                          userInfo?.gymId?.stateName ===
                                            "Tamil Nadu"
                                          ? "https://www.youtube.com/watch?v=gpq1lJZioKQ"
                                          : "https://youtu.be/o7Y5TuxL0I4",
                                        "_blank"
                                      );
                                    }}
                                  />
                                </span>
                              </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/dietPlan">
                              <Nav.Link
                                disabled={
                                  userInfo?.gymId?.subscriptionType !==
                                    "Premium" &&
                                  userInfo?.gymId?.subscriptionType !== "Free"
                                }
                              >
                                <IoFastFoodSharp
                                  style={{ marginRight: "2px" }}
                                />
                                Diet Plans
                                <span>
                                  <MdOutlinePlayCircleOutline
                                    className="videoIconStyle"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent link click bubbling
                                      e.preventDefault(); // prevent navigation
                                      window.open(
                                        !userInfo?.gymId?.stateName ||
                                          userInfo?.gymId?.stateName === null ||
                                          userInfo?.gymId?.stateName ===
                                            undefined ||
                                          userInfo?.gymId?.stateName ===
                                            "Tamil Nadu"
                                          ? "https://www.youtube.com/watch?v=osVWMFSh3sM"
                                          : "https://youtu.be/o7Y5TuxL0I4",
                                        "_blank"
                                      );
                                    }}
                                  />
                                </span>
                              </Nav.Link>
                            </LinkContainer>

                            <LinkContainer to="/whatsAppMessages">
                              <Nav.Link>
                                <FaWhatsappSquare
                                  style={{ marginRight: "2px" }}
                                />
                                {
                                  preferredLanguage[selectedLanguage]
                                    ?.wsNotification
                                }
                                <span>
                                  <MdOutlinePlayCircleOutline
                                    className="videoIconStyle"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent link click bubbling
                                      e.preventDefault(); // prevent navigation
                                      window.open(
                                        !userInfo?.gymId?.stateName ||
                                          userInfo?.gymId?.stateName === null ||
                                          userInfo?.gymId?.stateName ===
                                            undefined ||
                                          userInfo?.gymId?.stateName ===
                                            "Tamil Nadu"
                                          ? "https://youtu.be/pyROT7Gicdc"
                                          : "https://youtu.be/o7Y5TuxL0I4",
                                        "_blank"
                                      );
                                    }}
                                  />
                                </span>
                              </Nav.Link>
                            </LinkContainer>

                            <LinkContainer to="/qrCode">
                              <Nav.Link>
                                <MdQrCode2 style={{ marginRight: "2px" }} />
                                {
                                  preferredLanguage[selectedLanguage]
                                    ?.attendanceQrCode
                                }
                                <span>
                                  <MdOutlinePlayCircleOutline
                                    className="videoIconStyle"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent link click bubbling
                                      e.preventDefault(); // prevent navigation
                                      window.open(
                                        !userInfo?.gymId?.stateName ||
                                          userInfo?.gymId?.stateName === null ||
                                          userInfo?.gymId?.stateName ===
                                            undefined ||
                                          userInfo?.gymId?.stateName ===
                                            "Tamil Nadu"
                                          ? "https://youtu.be/i4KL4vrH31g"
                                          : "https://youtu.be/o7Y5TuxL0I4",
                                        "_blank"
                                      );
                                    }}
                                  />
                                </span>
                              </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to="/qrcodeRegister">
                              <Nav.Link>
                                <RiQrCodeFill style={{ marginRight: "2px" }} />
                                {preferredLanguage[selectedLanguage]?.regQrCode}
                                <span>
                                  <MdOutlinePlayCircleOutline
                                    className="videoIconStyle"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent link click bubbling
                                      e.preventDefault(); // prevent navigation
                                      // alert("video will play on youtube"); // your separate click action
                                      window.open(
                                        !userInfo?.gymId?.stateName ||
                                          userInfo?.gymId?.stateName === null ||
                                          userInfo?.gymId?.stateName ===
                                            undefined ||
                                          userInfo?.gymId?.stateName ===
                                            "Tamil Nadu"
                                          ? "https://www.youtube.com/watch?v=0_bImoDXFFE"
                                          : "https://youtu.be/o7Y5TuxL0I4",
                                        "_blank"
                                      );
                                    }}
                                  />
                                </span>
                              </Nav.Link>
                            </LinkContainer>
                            {/* <LinkContainer to="/payments">
                              <Nav.Link>
                                <FaMoneyBillAlt
                                  style={{ marginRight: "2px" }}
                                />
                                {
                                  preferredLanguage[selectedLanguage]
                                    ?.paymentsList
                                }
                              </Nav.Link>
                            </LinkContainer> */}
                          </>
                        ) : (
                          <></>
                        )}
                        {/* <LinkContainer to="/pendingPayments">
                          <Nav.Link>
                            <FaMoneyBillAlt style={{ marginRight: "2px" }} />
                            Pending Payments
                          </Nav.Link>
                        </LinkContainer> */}
                        <LinkContainer to="/regPendingUsers">
                          <Nav.Link>
                            <RiPassPendingFill style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]?.pendingReg
                            }{" "}
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://www.youtube.com/watch?v=o5BzfGysJwo"
                                      : "https://youtu.be/o7Y5TuxL0I4",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>
                      </>
                    )}

                    <hr
                      style={{ border: "1.5px solid grey", margin: "5px 0" }}
                    />
                    <div
                      onClick={() => setIsExpanded(!isExpanded)}
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "auto",
                        width: "100%",
                      }}
                    >
                      <strong style={{ flexGrow: 1 }}>
                        {"Gym Management"}{" "}
                      </strong>
                      {isExpanded ? (
                        <FaChevronUp style={{ color: "orange" }} />
                      ) : (
                        <FaChevronDown style={{ color: "orange" }} />
                      )}
                    </div>

                    {isExpanded && (
                      <>
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ||
                        userInfo.role === "Admin" ? (
                          <LinkContainer to="/packages">
                            <Nav.Link>
                              <CgMenuBoxed style={{ marginRight: "2px" }} />
                              Packages
                              {/* <span>
                                <MdOutlinePlayCircleOutline
                                  className="videoIconStyle"
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent link click bubbling
                                    e.preventDefault(); // prevent navigation
                                    window.open(
                                      !userInfo?.gymId?.stateName ||
                                        userInfo?.gymId?.stateName === null ||
                                        userInfo?.gymId?.stateName ===
                                          undefined ||
                                        userInfo?.gymId?.stateName ===
                                          "Tamil Nadu"
                                        ? "https://youtu.be/QwYDG5dWMNY"
                                        : "https://youtu.be/o7Y5TuxL0I4",
                                      "_blank"
                                    );
                                  }}
                                />
                              </span> */}
                            </Nav.Link>
                          </LinkContainer>
                        ) : null}
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ||
                        userInfo.role === "Admin" ? (
                          <LinkContainer to="/equipments">
                            <Nav.Link>
                              <CgGym style={{ marginRight: "2px" }} />
                              {
                                preferredLanguage[selectedLanguage]
                                  ?.equipmentManagement
                              }
                              <span>
                                <MdOutlinePlayCircleOutline
                                  className="videoIconStyle"
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent link click bubbling
                                    e.preventDefault(); // prevent navigation
                                    window.open(
                                      !userInfo?.gymId?.stateName ||
                                        userInfo?.gymId?.stateName === null ||
                                        userInfo?.gymId?.stateName ===
                                          undefined ||
                                        userInfo?.gymId?.stateName ===
                                          "Tamil Nadu"
                                        ? "https://youtu.be/QwYDG5dWMNY"
                                        : "https://youtu.be/o7Y5TuxL0I4",
                                      "_blank"
                                    );
                                  }}
                                />
                              </span>
                            </Nav.Link>
                          </LinkContainer>
                        ) : null}
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ? (
                          <LinkContainer to="/supplementSales">
                            <Nav.Link>
                              <CgGym style={{ marginRight: "2px" }} />
                              Supplement Sales
                            </Nav.Link>
                          </LinkContainer>
                        ) : null}
                        {/* {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ? (
                          gymId ? (
                            <LinkContainer to="/accounts">
                              <Nav.Link>
                                <MdAccountBalance
                                  style={{ marginRight: "2px" }}
                                />
                                {preferredLanguage[selectedLanguage]?.accounts}
                              </Nav.Link>
                            </LinkContainer>
                          ) : null
                        ) : null} */}
                        <LinkContainer to="/associatesAttendance">
                          <Nav.Link>
                            <MdManageAccounts style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]
                                ?.associateAttendanceList
                            }
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://youtu.be/eB24guU_N0M"
                                      : "https://youtu.be/o7Y5TuxL0I4",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/associates">
                          <Nav.Link>
                            <MdManageAccounts style={{ marginRight: "2px" }} />
                            {
                              preferredLanguage[selectedLanguage]
                                ?.adminManagement
                            }
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://youtu.be/sFlC6sQQliY"
                                      : "https://youtu.be/o7Y5TuxL0I4",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/gymProfile">
                          <Nav.Link>
                            {" "}
                            <RiBuilding4Fill style={{ marginRight: "3px" }} />
                            {preferredLanguage[selectedLanguage]?.gymProfile}
                          </Nav.Link>
                        </LinkContainer>
                        {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ? (
                          <LinkContainer to="/trends">
                            <Nav.Link>
                              {" "}
                              <AiTwotoneDatabase
                                style={{ marginRight: "2px" }}
                              />
                              {
                                preferredLanguage[selectedLanguage]
                                  ?.attendancePage.todaysTrend
                              }
                              <span>
                                <MdOutlinePlayCircleOutline
                                  className="videoIconStyle"
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent link click bubbling
                                    e.preventDefault(); // prevent navigation
                                    window.open(
                                      !userInfo?.gymId?.stateName ||
                                        userInfo?.gymId?.stateName === null ||
                                        userInfo?.gymId?.stateName ===
                                          undefined ||
                                        userInfo?.gymId?.stateName ===
                                          "Tamil Nadu"
                                        ? "https://youtu.be/mV0tRgu1WQI"
                                        : "https://youtu.be/o7Y5TuxL0I4",
                                      "_blank"
                                    );
                                  }}
                                />
                              </span>
                            </Nav.Link>
                          </LinkContainer>
                        ) : (
                          <></>
                        )}
                        <LinkContainer to="/events">
                          <Nav.Link>
                            {" "}
                            <RiCalendarEventFill
                              style={{ marginRight: "3px" }}
                            />
                            Gym Events
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://youtu.be/DK_HGygOnzc"
                                      : "https://youtu.be/DK_HGygOnzc",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/changeAppColors">
                          <Nav.Link>
                            {" "}
                            <IoIosColorPalette style={{ marginRight: "3px" }} />
                            Change App Colors
                            <span>
                              <MdOutlinePlayCircleOutline
                                className="videoIconStyle"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent link click bubbling
                                  e.preventDefault(); // prevent navigation
                                  window.open(
                                    !userInfo?.gymId?.stateName ||
                                      userInfo?.gymId?.stateName === null ||
                                      userInfo?.gymId?.stateName ===
                                        undefined ||
                                      userInfo?.gymId?.stateName ===
                                        "Tamil Nadu"
                                      ? "https://youtu.be/M4ryptgNDZo"
                                      : "https://youtu.be/o7Y5TuxL0I4",
                                    "_blank"
                                  );
                                }}
                              />
                            </span>
                          </Nav.Link>
                        </LinkContainer>
                        <LinkContainer to="/funActs">
                          <Nav.Link>
                            {" "}
                            <IoIosColorPalette style={{ marginRight: "3px" }} />
                            Fun-Fit Challenge
                          </Nav.Link>
                        </LinkContainer>
                        {/* <LinkContainer to="/packages">
                          <Nav.Link>
                            <CgMenuBoxed style={{ marginRight: "2px" }} />
                            Packages
                          </Nav.Link>
                        </LinkContainer> */}
                        {/* {userInfo.role === "owner" ||
                        userInfo.role === "Super Admin" ||
                        userInfo.role === "Admin" ? (
                          <LinkContainer to="/dashboard">
                            <Nav.Link>
                              <FaChartLine style={{ marginRight: "2px" }} />
                              {preferredLanguage[selectedLanguage]?.analytics}
                            </Nav.Link>
                          </LinkContainer>
                        ) : (
                          <></>
                        )} */}
                      </>
                    )}
                  </Nav>
                  {/* </Navbar.Collapse> */}
                </Container>
              </Navbar>
            </aside>
          ) : (
            <aside
              // className={`${userInfo.themeColor}ThemeHeaderLeft`}
              style={{
                width: leftMenuOpen ? "16rem" : "3rem", // Adjust width as needed
                // display: "none",
                height: "100vh", // Full viewport height
                position: "fixed", // Keep it fixed on the left
                top: "6.2rem",
                left: "0",
                borderRight: "1px solid #ccc",
                padding: "4px",
                overflowY: "auto", // Allow scrolling for long content
              }}
            >
              {/* <div>
                {!leftMenuOpen && (
                  <button
                    style={{
                      backgroundColor: "orange",
                      border: "none",
                      padding: "10px",
                      color: "white",
                      cursor: "pointer",
                      // Align the button to the right
                      marginBottom: "3px", // Add some spacing
                    }}
                    onClick={(e) => setExpandMenu(true)}
                  >
                    <GiHamburgerMenu style={{ marginRight: "2px" }} />
                  </button>
                )}
              </div> */}
            </aside>
          )}
        </>
      ) : (
        <></>
      )}
    </header>
  );
};

export default HeaderLeft;
